module.exports = __webpack_public_path__ + "static/media/1026012.eb6f3220.jpg";